var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682,
    height: 682,
    viewBox: "0 0 682 682",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 341,
    cy: 341,
    r: 339.5,
    stroke: "url(#paint0_linear_3933_19494)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3933_19494",
    x1: 430.805,
    y1: 763.996,
    x2: 451.63,
    y2: 214.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB69F"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x1",
    values: "379.563; 100; 379.563",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "1100.92; 200; 1100.92",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x2",
    values: "1022; 500; 1022",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "442; 800; 442",
    dur: "4s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCircle);
export default __webpack_public_path__ + "static/media/BigCircle.1d4559a4c90eab31c61da65220814148.svg";
export { ForwardRef as ReactComponent };